export default __webpack_public_path__ + "images/7E.fe80645.png";